import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import { useTrackVisibility } from 'react-intersection-observer-hook';
// api
import { getProductsAuthor, getProductsByEditorial } from 'api/products';
//helpers
import { goUp } from 'helpers';
// components
import ItemList from 'components/itemList/item';
import PaginationLoader from 'components/loader/PaginationLoader';
import Head from 'components/metatags_helmet/metatags';
import BreadCrumb from 'components/breadcrumb/BreadCrumb';

const CardDetail = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [listName, setListName] = useState(null);
  //pagination
  const [ref, { isVisible }] = useTrackVisibility();
  const [isLoading, setIsLoading] = useState(true);
  const [next, setNext] = useState(null);
  const [maxPage, setMaxPage] = useState(null);
  const [page, setPage] = useState(1);
  const type = location?.pathname.includes('autor') ? 'autor' : 'editorial';
  const PAGE_SIZE = 6;

  const getProducts = async (page = 1) => {
    setIsLoading(page > 1);
    const payload = {
      page: page,
      page_size: PAGE_SIZE,
      fields: 'id,title,image,authors,price,iva,type,saved,has_stock',
    };
    try {
      let response = null;
      if (type === 'autor') {
        response = await getProductsAuthor(location.state, payload);
      } else if (type === 'editorial') {
        response = await getProductsByEditorial(location.state, payload);
      }

      if (response) {
        const { status, data } = response;
        if (status === 200) {
          if (page === 1) {
            setListName(data?.author?.nombre_autor || data?.results?.editorial?.nombre_fiscal);
            goUp();
            setProducts(type === 'autor' ? data?.results : data?.results?.products);
          } else {
            if (type === 'autor') {
              setProducts((prev) => [...(prev || []), ...data?.results]);
            } else if (type === 'editorial') {
              setProducts((prev) => [...(prev || []), ...data?.results?.products]);
            }
          }
          setMaxPage(data?.total_pages || Math.ceil(data?.count / PAGE_SIZE));
          setNext(data?.next);
        } else {
          console.error('Error: Unexpected status code', status);
        }
      } else {
        console.error('Error: Response is undefined');
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getProducts();
  }, [location]);

  // next API calls
  useEffect(() => {
    if (page < maxPage && next) {

      const getNewItems = async (newValuePage) => {
        await getProducts(newValuePage);
        setPage(newValuePage);
      };
      if (isVisible) {
        let newValuePage = page + 1;
        getNewItems(newValuePage);
      }
    }
  }, [isVisible, page, next, maxPage]);

  return (
    <>
      <Head title={listName} />
      <Container className="margin-bottom-md px-0 list-section container-fluid">
        <Row className="p-0">
          <BreadCrumb breadcrumbTitle={listName} />
        </Row>
        <Row className="itemsRow">
          {products?.map((item, index) => (
            <Col md={4} lg={2} sm={6} key={`itmes#${index}`} className='mb-5'>
              <ItemList key={index} data={item} />
            </Col>
          ))}
          {!isLoading && next && <div aria-hidden="true" ref={ref}></div>}
          {isLoading && (
            <div className="container">
              <PaginationLoader visibility={isLoading} />
            </div>
          )}
        </Row>
      </Container>
    </>
  );
};
export default CardDetail;